import {
  Button,
  Checkbox,
  Classes,
  Dialog,
  FormGroup
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { MvaStoreRS } from "../../stores/mvas/MvaStoreRS";
import { MDBCol, MDBRow } from "mdbreact";
import { IMvaRS } from "../../model";

interface MvaRsDialogEditProps {
  mva: IMvaRS;
  onClose: () => void;
}

interface MvaRsDialogEditState {
}

@observer
export class MvaRsDialogEdit
  extends React.Component<MvaRsDialogEditProps, MvaRsDialogEditState> {
  obs = observable({
    mva: {} as IMvaRS,
    segmentos_selecionados: [] as any
  })

  async componentDidMount() {

    this.obs.mva = { ...this.props.mva }

  }

  /**
  * Salva a edição de flags (`seg_auto_pecas` e `seg_vet_pet`) de uma MVA no contexto do RS.
  *
  * A função:
  * - Monta um objeto `params` com:
  *   - `id`: identificado pelo campo `_id` do objeto `mva`.
  *   - `seg_auto_pecas`: valor booleano (padrão `false` se indefinido).
  *   - `seg_vet_pet`: valor booleano (padrão `false` se indefinido).
  * - Chama `MvaStoreRS.doSaveEditMvaRs(params)` para persistir os dados.
  * - Se o salvamento for bem-sucedido (`res` truthy), fecha o modal via `this.props.onClose()`.
  *
  * ## Efeitos colaterais
  * - Realiza chamada assíncrona à store `MvaStoreRS`.
  * - Fecha a interface/modal de edição em caso de sucesso.
  *
  * @async
  * @param {Object} mva Objeto da MVA a ser editada.
  * @param {string} mva._id Identificador único do registro (MongoDB ObjectId).
  * @param {boolean} [mva.seg_auto_pecas=false] Flag de segmento automotivo.
  * @param {boolean} [mva.seg_vet_pet=false] Flag de segmento veterinário/pet.
  *
  * @returns {Promise<void>} Promise resolvida após salvar; interrompe execução se o `res` for falsy.
  */

  handleSaveEdit = async (mva) => {

    const params = {
      id: mva._id,
      seg_auto_pecas: mva.seg_auto_pecas || false,
      seg_vet_pet: mva.seg_vet_pet || false,
      seg_refrigerantes: mva.seg_refrigerantes || false,
      seg_agua_out: mva.seg_agua_out || false,
      seg_lamp_reatores: mva.seg_lamp_reatores || false,
      seg_mat_limpeza: mva.seg_mat_limpeza || false,
      seg_pneumaticos_prot: mva.seg_pneumaticos_prot || false,
      seg_alimenticios: mva.seg_alimenticios || false,
      seg_perf_cosm: mva.seg_perf_cosm || false,
      seg_eletro: mva.seg_eletro || false,
      seg_racoes: mva.seg_racoes || false,
      seg_sorvetes_fab: mva.seg_sorvetes_fab || false,
      seg_tintas: mva.seg_tintas || false,
      seg_mat_construcao: mva.seg_mat_construcao || false,
      seg_veiculos_automotores: mva.seg_veiculos_automotores || false,
      seg_veiculos_novos: mva.seg_veiculos_novos || false,
      seg_medicamentos_humano: mva.seg_medicamentos_humano || false
    }

    let res = await MvaStoreRS.doSaveEditMvaRs(params);

    if (res) {

      this.props.onClose()

    }

  };

  render() {

    if (!this.obs.mva) {
      return null;
    }

    return (
      <Dialog
        isOpen={true}
        onClose={this.props.onClose}
        style={{ width: 600, height: 400 }}
      >
        <div className={Classes.DIALOG_HEADER}>
          <h2 className="title-no-bottom">Editar MVA</h2>
        </div>

        <div className={Classes.DIALOG_BODY}>
          <MDBRow>
            <MDBCol>
              <div className={Classes.DIALOG_BODY}>
                <FormGroup
                  label="Selecione os segmentos:"
                  labelFor="segmentos"
                  >
                  <div style ={{overflow: "auto", maxHeight: 400}}>
                    <Checkbox
                      label={"Autopeças"}
                      checked={this.obs.mva.seg_auto_pecas}
                      onChange={(event: any) => this.obs.mva.seg_auto_pecas = event.target.checked}
                    />
                    <Checkbox
                      label={"Veterinário/pet"}
                      checked={this.obs.mva.seg_vet_pet}
                      onChange={(event: any) => this.obs.mva.seg_vet_pet = event.target.checked}
                    />
                    <Checkbox
                      label={"Refrigerantes"}
                      checked={this.obs.mva.seg_refrigerantes}
                      onChange={(event: any) => this.obs.mva.seg_refrigerantes = event.target.checked}
                    />
                    <Checkbox
                      label={"Aguas e outras bebidas"}
                      checked={this.obs.mva.seg_agua_out}
                      onChange={(event: any) => this.obs.mva.seg_agua_out = event.target.checked}
                    />
                    <Checkbox
                      label={"Lâmpadas, reatores e starter"}
                      checked={this.obs.mva.seg_lamp_reatores}
                      onChange={(event: any) => this.obs.mva.seg_lamp_reatores = event.target.checked}
                    />
                    <Checkbox
                      label={"Materiais de limpeza"}
                      checked={this.obs.mva.seg_mat_limpeza}
                      onChange={(event: any) => this.obs.mva.seg_mat_limpeza = event.target.checked}
                    />
                    <Checkbox
                      label={"Pneumáticos, câmaras de ar e protetores de borracha"}
                      checked={this.obs.mva.seg_pneumaticos_prot}
                      onChange={(event: any) => this.obs.mva.seg_pneumaticos_prot = event.target.checked}
                    />
                    <Checkbox
                      label={"Produtos alimentícios"}
                      checked={this.obs.mva.seg_alimenticios}
                      onChange={(event: any) => this.obs.mva.seg_alimenticios = event.target.checked}
                    />
                    <Checkbox
                      label={"Produtos de perfumaria e de higiene pessoal e cosméticos"}
                      checked={this.obs.mva.seg_perf_cosm}
                      onChange={(event: any) => this.obs.mva.seg_perf_cosm = event.target.checked}
                    />
                    <Checkbox
                      label={"Produtos eletrônicos, eletroeletrônicos e eletrodomésticos"}
                      checked={this.obs.mva.seg_eletro}
                      onChange={(event: any) => this.obs.mva.seg_eletro = event.target.checked}
                    />
                    <Checkbox
                      label={"Rações para animais domésticos"}
                      checked={this.obs.mva.seg_racoes}
                      onChange={(event: any) => this.obs.mva.seg_racoes = event.target.checked}
                    />
                    <Checkbox
                      label={"Sorvetes e preparados para fabricação de sorvetes em máquinas"}
                      checked={this.obs.mva.seg_sorvetes_fab}
                      onChange={(event: any) => this.obs.mva.seg_sorvetes_fab = event.target.checked}
                    />
                    <Checkbox
                      label={"Tintas e vernizes"}
                      checked={this.obs.mva.seg_tintas}
                      onChange={(event: any) => this.obs.mva.seg_tintas = event.target.checked}
                    />
                    <Checkbox
                      label={"Material de construção"}
                      checked={this.obs.mva.seg_mat_construcao}
                      onChange={(event: any) => this.obs.mva.seg_mat_construcao = event.target.checked}
                    />
                    <Checkbox
                      label={"Veículos automotores novos"}
                      checked={this.obs.mva.seg_veiculos_automotores}
                      onChange={(event: any) => this.obs.mva.seg_veiculos_automotores = event.target.checked}
                    />
                    <Checkbox
                      label={"Veículos novos de duas e três rodas motorizados"}
                      checked={this.obs.mva.seg_veiculos_novos}
                      onChange={(event: any) => this.obs.mva.seg_veiculos_novos = event.target.checked}
                    />
                    <Checkbox
                      label={"Medicamentos de uso humano e outros produtos farmacêuticos"}
                      checked={this.obs.mva.seg_medicamentos_humano}
                      onChange={(event: any) => this.obs.mva.seg_medicamentos_humano = event.target.checked}
                    />
                  </div>
                </FormGroup>
              </div>
            </MDBCol>
          </MDBRow>

        </div>

        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={this.props.onClose} />
            <Button text="Salvar" intent="primary" onClick={() => this.handleSaveEdit(this.obs.mva)} />
          </div>
        </div>
      </Dialog>
    );
  }
}
